<template>
  <v-flex xs12 sm6>
    <v-flex xs10 sm6 offset-xs1 offset-sm3>
      <v-select
        v-bind:items="schools"
        item-text="name"
        item-value="id"
        v-model="schoolId"
        :label="$t('questionnaires.new.SCHOOL_SELECT')"
        autocomplete
        required
        v-show="this.$auth.check('EXPERT')"
      >
        <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
        <template slot="item" slot-scope="data">{{ data.item.name }}</template>
      </v-select>
    </v-flex>
    <v-flex xs10 sm6 offset-xs1 offset-sm3>
      <v-select
        v-bind:items="teachers"
        item-text="name"
        item-value="id"
        v-model="teacherId"
        @change="updateValue"
        :label="$t('questionnaires.new.TEACHER_SELECT')"
        :disabled="!canSelectTeacher"
        required
        v-show="this.$auth.check('EXPERT')"
      >
        <template slot="selection" slot-scope="data">

          <v-avatar>
            <v-icon>person</v-icon>
          </v-avatar>
          {{ data.item.surname1 + ' ' + data.item.surname2 + ', ' + data.item.name}}

        </template>

        <template slot="item" slot-scope="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <v-icon>person</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="data.item.surname1 + ' ' + data.item.surname2 + ', ' + data.item.name"></v-list-tile-title>
              <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>

      </v-select>
    </v-flex>
    <v-progress-circular v-bind:size="50" indeterminate class="primary--text" v-show="loading"></v-progress-circular>
  </v-flex>
</template>

<script>
  import {SchoolResource} from '../../api/school'
  export default {
    name: 'TeacherSelector',
    props: ['value'],
    data () {
      return {
        schoolId: null,
        teacherId: null,
        schools: [],
        teachers: [],
        teachersLoaded: false,
        loading: false,
        currentTeacher: {}
      }
    },
    watch: {
      value (val) {
        this.currentTeacher = val
      },
      'schoolId': function () {
        if (this.schoolId !== '') {
          this.loading = true
          this.teachersLoaded = false
          this.teacherId = null
          SchoolResource().getTeachers({id: this.schoolId}).then(
            response => {
              this.teachers = response.data
              this.teachersLoaded = true
              this.loading = false
            },
            response => {
              console.log('error in teachers endpoint')
            }
          )
        }
      },
      'teacherId': function () {
        this.currentTeacher = this.getItemById(this.teachers, this.teacherId)
        // this.getResultsOfTeacher(this.teacherId)
      }
    },
    computed: {
      schoolSelected: function () {
        return this.schoolId !== '' && this.schoolId !== null
      },
      canSelectTeacher: function () {
        return this.schoolSelected && this.teachersLoaded
      }
    },
    mounted () {
      SchoolResource().get().then(
        response => {
          this.schools = response.data
        },
        response => {
          console.log('error in schools endpoint')
        }
      )
    },
    methods: {
      updateValue: function (value) {
        this.$emit('input', value)
      },
      getItemById: function (collection, id) {
        return this._.find(collection, function (i) {
          return i.id === id
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/users/TeacherSelector.vue